"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUSState = exports.isCNPhone = exports.isUSPhone = exports.isEmail = void 0;
var states_1 = require("./states");
function isEmail(value) {
    var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(value);
}
exports.isEmail = isEmail;
function isUSPhone(value) {
    var regex = /^\+1[0-9]{10}$/;
    return regex.test(value);
}
exports.isUSPhone = isUSPhone;
function isCNPhone(value) {
    var regex = /^\+86[0-9]{11}$/;
    return regex.test(value);
}
exports.isCNPhone = isCNPhone;
function isUSState(value) {
    return value in states_1.states;
}
exports.isUSState = isUSState;
